exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{margin:0;padding:0;box-sizing:border-box}*{font-size:16px}.settings-bar{position:fixed;top:10px;right:10px}.main{padding-right:30px}a{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./frontend/style.css
// module id = 11
// module chunks = 0